export const Tracker = Symbol('Tracker');

export interface Tracker {
    track: (module: string, action: string, others?: any) => void;
}
